import { defineMessages } from "react-intl";

import {
	covidVaccinationMessages,
	fluShotMessages,
	havVaccinationMessages,
	hbvVaccinationMessages,
	hpvVaccinationMessages,
	meningococcusVaccinationMessages,
	pneumococusVaccinationMessages,
	validator
} from "lib/build/forms/htx/vaccinationStatus";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	vaccinationStatus: {
		id: "form.htx_vaccination_status",
		defaultMessage: "Vakcinációs státusz"
	},
	fluShot: {
		id: "form.htx_vaccination_status.flu_shot",
		defaultMessage: "Influenza (1 éven belül)"
	},
	pneumococusVaccination: {
		id: "form.htx_vaccination_status.pneumococus_vaccination",
		defaultMessage: "Pneumococcus (5 éven belül)"
	},
	hbvVaccination: {
		id: "form.htx_vaccination_status.hbv_vaccination",
		defaultMessage: "HBV"
	},
	havVaccination: {
		id: "form.htx_vaccination_status.hav_vaccination",
		defaultMessage: "HAV"
	},
	meningococcusVaccination: {
		id: "form.htx_vaccination_status.meningococcus_vaccination",
		defaultMessage: "Meningococcus"
	},
	hpvVaccination: {
		id: "form.htx_vaccination_status.hpv_vaccination",
		defaultMessage: "HPV"
	},
	covidVaccination: {
		id: "form.htx_vaccination_status.covid_vaccination",
		defaultMessage: "Covid"
	}
});

const fields: { [key: string]: FieldData } = {
	fluShot: {
		type: "field",
		path: ["fluShot"],
		label: messages.fluShot,
		errorMessages: genericErrorMessages,
		input: { type: "button-group", props: { labels: fluShotMessages } }
	},
	pneumococusVaccination: {
		type: "field",
		path: ["pneumococusVaccination"],
		label: messages.pneumococusVaccination,
		errorMessages: genericErrorMessages,
		input: {
			type: "button-group",
			props: { labels: pneumococusVaccinationMessages }
		}
	},
	hbvVaccination: {
		type: "field",
		path: ["hbvVaccination"],
		label: messages.hbvVaccination,
		errorMessages: genericErrorMessages,
		input: {
			type: "button-group",
			props: { labels: hbvVaccinationMessages }
		}
	},
	havVaccination: {
		type: "field",
		path: ["havVaccination"],
		label: messages.havVaccination,
		errorMessages: genericErrorMessages,
		input: {
			type: "button-group",
			props: { labels: havVaccinationMessages }
		}
	},
	meningococcusVaccination: {
		type: "field",
		path: ["meningococcusVaccination"],
		label: messages.meningococcusVaccination,
		errorMessages: genericErrorMessages,
		input: {
			type: "button-group",
			props: { labels: meningococcusVaccinationMessages }
		}
	},
	hpvVaccination: {
		type: "field",
		path: ["hpvVaccination"],
		label: messages.hpvVaccination,
		errorMessages: genericErrorMessages,
		input: {
			type: "button-group",
			props: { labels: hpvVaccinationMessages }
		}
	},
	covidVaccination: {
		type: "field",
		path: ["covidVaccination"],
		label: messages.covidVaccination,
		errorMessages: genericErrorMessages,
		input: {
			type: "button-group",
			props: { labels: covidVaccinationMessages }
		}
	}
};

const fieldset: FieldsetData = {
	rows: [
		{
			columns: [
				{ width: 6, field: fields.fluShot },
				{ width: 6, field: fields.pneumococusVaccination }
			]
		},
		{
			columns: [
				{ width: 6, field: fields.hbvVaccination },
				{ width: 6, field: fields.havVaccination }
			]
		},
		{
			columns: [
				{ width: 6, field: fields.meningococcusVaccination },
				{ width: 6, field: fields.hpvVaccination }
			]
		},
		{ columns: [{ width: 6, field: fields.covidVaccination }] }
	]
};

export const node: LeafNode = {
	id: "vaccinationStatus",
	value: {
		title: messages.vaccinationStatus,
		validator,
		fieldset,
		isImportant: true,
		applyCurrentDate: true
	}
};
